import React, { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import '../Style/AppearanceSettings.css';

const AppearanceSettings = () => {
  const { theme, setTheme } = useContext(ThemeContext);

  return (
    <div className="appearance-settings">
      <h2>Appearance</h2>
      <p>Choose how Global Legends looks on this device.</p>

      <div className="appearance-card">
        <div>
          <h3>Theme</h3>
          <p>Switch between light and dark mode.</p>
        </div>

        <div className="theme-options">
          <button
            className={`theme-option ${theme === 'light' ? 'active' : ''}`}
            onClick={() => setTheme('light')}
          >
            ☀️ Light
          </button>

          <button
            className={`theme-option ${theme === 'dark' ? 'active' : ''}`}
            onClick={() => setTheme('dark')}
          >
            🌙 Dark
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppearanceSettings;
